<template>
  <div>
    <!-- 疯狂动物城 第1关-->
    <div v-if="id==1">
      <div v-if="playAgain==true || arrCosPlay[0]=='0'">
        <Intro v-if="!introFinished" :id="id" @finish-intro="handleFinishIntro" @backMission="handleBackMission"/>
        <AnimalTown v-if="introFinished" :id="id"/>
      </div>
      <div v-if="playAgain==false && arrCosPlay[0]=='1'">
        <ZooResult :id="id"/>
      </div>
    </div>
    <!-- 生涯罗盘 第2关-->
    <div v-if="id==2">
      <div v-if="playAgain==true || arrCosPlay[1]=='0'">
        <Intro v-if="!introFinished" :id="id" @finish-intro="handleFinishIntro" @backMission="handleBackMission"/>
        <LiveValue v-if="introFinished" :id="id"/>
      </div>
      <div v-if="playAgain==false && arrCosPlay[1]=='1'">
        <LiveReport :id="id"/>
      </div>
    </div>
    <!-- 大学生ToDoList 第3关-->
    <div v-if="id==3">
      <div v-if="playAgain==true || arrCosPlay[2]=='0'">
        <Intro v-if="!introFinished" :id="id" @finish-intro="handleFinishIntro" @backMission="handleBackMission"/>
        <ToDoList v-if="introFinished" :id="id"/>
      </div>
      <div v-if="playAgain==false && arrCosPlay[2]=='1'">
        <ToDoReport :id="id"/>
      </div>
    </div>
    <!-- 职业倾向测评 第4关-->
    <div v-if="id==4">
      <div v-if="playAgain==true || arrCosPlay[3]=='0'">
        <Intro v-if="!introFinished" :id="id" @finish-intro="handleFinishIntro" @backMission="handleBackMission"/>
        <CareerOrientation v-if="introFinished" :id="id"/>
      </div>
      <div v-if="playAgain==false && arrCosPlay[3]=='1'">
        <HollandReport :id="id"/>
      </div>
    </div>
    <!-- 职业世界探索 第5关-->
    <div v-if="id==5">
      <div v-if="playAgain==true || arrCosPlay[4]=='0'">
        <Intro v-if="!introFinished" :id="id" @finish-intro="handleFinishIntro" @backMission="handleBackMission"/>
        <CareerExplore v-if="introFinished" :id="id"/>
      </div>
      <div v-if="playAgain==false && arrCosPlay[4]=='1'">
        <CareerExploreReport :id="id"/>
      </div>
    </div>
    <!-- 职业倾向匹配 第6关-->
    <div v-if="id==6">
      <div v-if="playAgain==true || arrCosPlay[5]=='0'">
        <Intro v-if="!introFinished" :id="id" @finish-intro="handleFinishIntro" @backMission="handleBackMission"/>
        <CareerMatch v-if="introFinished" :id="id"/>
      </div>
      <div v-if="playAgain==false && arrCosPlay[5]=='1'">
        <CareerMatchReport :id="id"/>
      </div>
    </div>
    <!-- 优秀大学生图鉴 第7关-->
    <div v-if="id==7">
      <div v-if="playAgain==true || arrCosPlay[6]=='0'">
        <Intro v-if="!introFinished" :id="id" @finish-intro="handleFinishIntro" @backMission="handleBackMission"/>
        <Excellent v-if="introFinished" :id="id"/>
      </div>
      <div v-if="playAgain==false && arrCosPlay[6]=='1'">
        <ExcellentReport :id="id"/>
      </div>
    </div>
    <!-- 职业能力知多少 第8关-->
    <div v-if="id==8">
      <div v-if="playAgain==true || arrCosPlay[7]=='0'">
        <Intro v-if="!introFinished" :id="id" @finish-intro="handleFinishIntro" @backMission="handleBackMission"/>
        <Competence v-if="introFinished" :id="id"/>
      </div>
      <div v-if="playAgain==false && (arrCosPlay[7]=='1'||arrCosPlay[7]=='-1')">
        <KnowlegeReport :id="id"/>
      </div>
    </div>
    <!-- 目标职位能力大赏 第9关-->
    <div v-if="id==9">
      <div v-if="playAgain==true || arrCosPlay[8]=='0'">
        <Intro v-if="!introFinished" :id="id" @finish-intro="handleFinishIntro" @backMission="handleBackMission"/>
        <Ability v-if="introFinished" :id="id"/>
      </div>
      <div v-if="playAgain==false && arrCosPlay[8]=='1'">
        <AbilityReport :id="id"/>
      </div>
    </div>
    <!-- 决策风格测评 第10关-->
    <div v-if="id==10">
      <div v-if="playAgain==true || arrCosPlay[9]=='0'">
        <Intro v-if="!introFinished" :id="id" @finish-intro="handleFinishIntro" @backMission="handleBackMission"/>
        <DecisionStyle v-if="introFinished" :id="id"/>
      </div>
      <div v-if="playAgain==false && arrCosPlay[9]=='1'">
        <DecisionReport :id="id"/>
      </div>
    </div>
    <!-- 毕业政策探索 第11关-->
    <div v-if="id==11">
      <div v-if="playAgain==true || arrCosPlay[10]=='0'">
        <Intro v-if="!introFinished" :id="id" @finish-intro="handleFinishIntro" @backMission="handleBackMission"/>
        <GraduationDestination v-if="introFinished" :id="id"/>
      </div>
      <div v-if="playAgain==false && arrCosPlay[10]=='1'">
        <GraduationReport :id="id"/>
      </div>
    </div>
    <!-- 我的决策产生 第12关-->
    <div v-if="id==12">
      <div v-if="playAgain==true || arrCosPlay[11]=='0'">
        <Intro v-if="!introFinished" :id="id" @finish-intro="handleFinishIntro" @backMission="handleBackMission"/>
        <DecisionMaking v-if="introFinished" :id="id"/>
      </div>
      <div v-if="playAgain==false && arrCosPlay[11]=='1'">
        <DecisionMakingReport :id="id"/>
      </div>
    </div>
    <!-- 生涯扫雷 第13关-->
    <div v-if="id==13">
      <div v-if="playAgain==true || arrCosPlay[12]=='0'">
        <Intro v-if="!introFinished" :id="id" @finish-intro="handleFinishIntro" @backMission="handleBackMission"/>
        <CddqSweeping v-if="introFinished" :id="id"/>
      </div>
      <div v-if="playAgain==false && arrCosPlay[12]=='1'">
        <CddqReport :id="id"/>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Intro from '@/page/intro'
import AnimalTown from '@/page/AnimalTown'
import ZooResult from '@/page/ZooResult'
import LiveValue from '@/page/LiveValue'
import LiveReport from '@/page/LiveReport'
import ToDoList from '@/page/ToDoList'
import ToDoReport from '@/page/ToDoReport'
import CareerOrientation from '@/page/CareerOrientation'
import HollandReport from '@/page/HollandReport'
import CareerExplore from '@/page/CareerExplore'
import CareerExploreReport from '@/page/CareerExploreReport'
import CareerMatch from '@/page/CareerMatch'
import CareerMatchReport from '@/page/CareerMatchReport'
import Excellent from '@/page/Excellent'
import ExcellentReport from '@/page/ExcellentReport'
import Competence from '@/page/Competence'
import KnowlegeReport from '@/page/KnowlegeReport'
import Ability from '@/page/Ability'
import AbilityReport from '@/page/AbilityReport'
import CddqSweeping from '@/page/CddqSweeping'
import CddqReport from '@/page/CddqReport'
import DecisionStyle from '@/page/DecisionStyle'
import DecisionReport from '@/page/DecisionReport'
import GraduationDestination from '@/page/GraduationDestination'
import GraduationReport from '@/page/GraduationReport'
import DecisionMaking from '@/page/DecisionMaking'
import DecisionMakingReport from '@/page/DecisionMakingReport'

export default {
  name: 'MissionDetail',
  props: {
    id: Number,
  },
  components:{
    'Intro':Intro,
    'AnimalTown':AnimalTown,
    'ZooResult':ZooResult,
    'LiveValue':LiveValue,
    'LiveReport':LiveReport,
    'ToDoList':ToDoList,
    'ToDoReport':ToDoReport,
    'CareerOrientation':CareerOrientation,
    'HollandReport':HollandReport,
    'CareerExplore':CareerExplore,
    'CareerExploreReport':CareerExploreReport,
    'CareerMatch':CareerMatch,
    'CareerMatchReport':CareerMatchReport,
    'Excellent':Excellent,
    'ExcellentReport':ExcellentReport,
    'Competence':Competence,
    'KnowlegeReport':KnowlegeReport,
    'Ability':Ability,
    'AbilityReport':AbilityReport,
    'DecisionStyle':DecisionStyle,
    'DecisionReport':DecisionReport,
    'GraduationDestination':GraduationDestination,
    'GraduationReport':GraduationReport,
    'DecisionMaking':DecisionMaking,
    'DecisionMakingReport':DecisionMakingReport,
    'CddqSweeping':CddqSweeping,
    'CddqReport':CddqReport
  },
  data () {
    return {
      playAgain: false,
      introFinished: false,
    }
  },

	computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
      arrCosPlay: state => state.shengyaUser.arrCosPlay,
    }),
	},
	beforeMount() {
    // console.log('开始 missionDetail beforeMount() 开启监听')
    this.$bus.$on('play-again', this.handlePlayAgain)
    this.$bus.$on('play-finish', this.handlePlayFinish)
    this.$bus.$on('result-view', this.handleResultView)
	},
  beforeDestroy () {
    // console.log('开始 missionDetail beforeDestroy() 关闭监听')
    this.$bus.$off('play-again')
    this.$bus.$off('play-finish')
    this.$bus.$off('result-view')
  },
  methods:{
    handlePlayFinish(shengyaUser) {
      this.playAgain = false
      console.log('开始 dispatch \'setUserInfo\'')
      store.dispatch('setUserInfo', shengyaUser)
      //发送闯关结束消息
      // store.dispatch('finishPlay', this.id)
    },
    handlePlayAgain() {
      this.playAgain = true
      this.introFinished = false
      this.shengyaUser.cosAnimal = ''
      store.dispatch('setUserInfo', this.shengyaUser)
    },
    handleFinishIntro(){
      this.introFinished = true
    },
    handleBackMission(){
      if (this.playAgain) {
        this.playAgain = false
      }
      else {
        this.$bus.$emit('back-mission')
      }
    },
    handleResultView(type){
      this.playAgain = true
      this.introFinished = true
      this.shengyaUser.cosAnimal = type
      store.dispatch('setUserInfo', this.shengyaUser)
    }
  }

}
</script>
<style>


</style>
